import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ea06d91e")

_pushScopeId("data-v-ea06d91e")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "待办类型", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "是否已处理", -1)
const _hoisted_5 = { class: "flex flexC button-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "去处理", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "详情", -1)
const _hoisted_8 = { class: "flex flexR mar-t-22" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, "车牌：粤S66666", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        modelValue: _ctx.params.type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.params.type = $event)),
        onChange: _ctx.selectChange,
        placeholder: "请选择",
        clearable: "",
        filterable: ""
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scheduleTypeList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _hoisted_4,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        modelValue: _ctx.params.is_deal,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.params.is_deal = $event)),
        onChange: _ctx.selectChange,
        placeholder: "请选择",
        clearable: "",
        filterable: ""
      }, {
        default: _withId(() => [
          _createVNode(_component_el_option, {
            label: "未处理",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "已处理",
            value: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"])
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "180"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.goDeal(scope.row))
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.goDetail(scope.row))
                }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "详情",
      "model-value": _ctx.dialog_model,
      center: "",
      width: 1000,
      "before-close": ()=>{_ctx.dialog_model = false}
    }, {
      default: _withId(() => [
        _createVNode("div", null, "提醒标题：" + _toDisplayString(_ctx.selectInfo.title), 1),
        _hoisted_9,
        _createVNode("div", null, "是否已处理：" + _toDisplayString(_ctx.selectInfo.deal_text), 1),
        _createVNode("div", null, "提醒时间：" + _toDisplayString(_ctx.selectInfo.create_time_text), 1)
      ]),
      _: 1
    }, 8, ["model-value", "before-close"])
  ]))
})